<script lang="ts">import { t, Verbiage } from "@infinitro/content";
export let width = "";
export let height = "";
export let backgroundImage = "";
export let backgroundColor = "";
export let backgroundColor2 = "";
export let backgroundImagePosition = "top";
export let backgroundImagePositionX = "right";
export let withInnerShadow = false;
export let alternative = false;
</script>

<button class="top-card" style="width: {width}; height: {height}; ">
	<div class="border-box {alternative ? 'border-box-alternative' : ''}">
		<div
			class="top-card-content"
			style="background-image: linear-gradient(to bottom, {backgroundColor}, {backgroundColor2});"
		>
			<img
				alt={$t(Verbiage.illustration_alt, 'alts')}
				class="background-image"
				class:background-image-top={backgroundImagePosition === 'top'}
				class:background-image-center={backgroundImagePosition === 'center'}
				class:background-image-bottom={backgroundImagePosition === 'bottom'}
				class:background-image-left={backgroundImagePositionX === 'left'}
				class:background-image-center-x={backgroundImagePositionX === 'center'}
				class:background-image-right={backgroundImagePositionX === 'right'}
				src={backgroundImage}
			/>
			<slot name="content"></slot>
		</div>
	</div>
	{#if withInnerShadow}
		<div class="inner-shadow"></div>
	{/if}
</button>

<style>
	.top-card {
		position: relative;
		display: flex;
		cursor: pointer;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		border-radius: 18px;
		background-color: transparent;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family: var(--font-main)
}

	.top-card-content {
		position: relative;
		height: 100%;
		width: 100%;
		border-radius: 18px;
		background-color: transparent
}

	.inner-shadow {
		position: absolute;
		bottom: 0px;
		height: 40%;
		width: 100%;
		border-radius: 16px;
		background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
		--tw-gradient-from: transparent var(--tw-gradient-from-position);
		--tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
		--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
		--tw-gradient-to: #000 var(--tw-gradient-to-position);
		opacity: 0.6;
		z-index: 10
}

	.background-image {
		position: absolute;
		top: 0px;
		left: 50%;
		z-index: 5;
		height: 100%;
		width: auto;
		min-width: 100%;
		max-width: none;
		--tw-translate-x: -50%;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		border-radius: 16px;
		-o-object-fit: cover;
		   object-fit: cover
}

	.background-image-top {
		-o-object-position: top;
		   object-position: top
}

	.background-image-center {
		-o-object-position: center;
		   object-position: center
}

	.background-image-bottom {
		-o-object-position: bottom;
		   object-position: bottom
}

	.border-box {
		position: absolute;
		height: 100%;
		width: 100%;
		border-radius: 16px;
		z-index: 10
}

	.border-box-alternative {
		overflow: hidden
}

	.background-image-center-x {
		left: 50%;
		--tw-translate-x: -50%;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		-o-object-position: center;
		   object-position: center
}

	.background-image-left {
		left: 0px;
		right: auto;
		--tw-translate-x: 0px;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		-o-object-position: left;
		   object-position: left
}

	.background-image-right {
		right: 0px;
		left: auto;
		--tw-translate-x: 0px;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		-o-object-position: right;
		   object-position: right
}
</style>
